import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate, useParams } from "react-router-dom";
import s from './itemAnalysis.module.css';
import { Link } from "react-router-dom";
import {getData, postData, postFormData} from '../middleware/apiMiddleware';
import {modifiedDate} from '../middleware/dateControl';
import {getGeneralStorage, setGeneralStorage} from '../middleware/dataStorage';
import { useOutletContext } from "react-router-dom";
import CreateBook from '../components/CreateBook';
import {ItemTypeIcon} from '../middleware/MyConstant';
import {GreenButton} from '../components/MyButton';

import {Image} from 'react-bootstrap';

import uploadPng from'../asset/upload.png';

import starPng from'../asset/star.png';
import starDarkPng from'../asset/star-dark.png';
import jailPng from'../asset/jail.png';

import KeyLuckyBagPanel from '../components/KeyLuckyBagPanel.js';
import KeyComplexSentencePanel from '../components/KeyComplexSentencePanel.js';
import {BlueButton} from '../components/MyButton';
import {keyItemList} from '../middleware/MyConstant';

export default function ItemAnalysis(props) {
	const navigate = useNavigate();
	const [logger] = useOutletContext();
	
	const [searchParams, setSearchParams] = useSearchParams();
	const [target, setTarget] = useState(getGeneralStorage('itemAnalysisMain') ?? "key-reading");
	const [format, setFormat] = useState(getGeneralStorage('itemAnalysisFormat') ?? "basic");
	const [page, setPage] = useState(1);
	const [limit, setLimit] = useState(100);
	const [itemId, setItemId] = useState(null);
	
	const [itemData, setItemData] = useState([]);
	
	const [totalCnt, setTotalCnt] = useState(0);
	
	const [keyData, setKeyData] = useState(keyItemList);
	const [babyData, setBabyData] = useState(babyDefaultData);

	const [toggleOn, setToggleOn] = useState(false);
	
	const fetchData = async (target, format, page, limit, itemId) => {		
		
		if (target == 'item' && !itemId) {
			return;
		}
		
		let myParam = {target, format, page, limit, itemId};
		
		setItemData([]);
		
		getData('item/listItems?' + (new URLSearchParams(myParam)).toString(), navigate)
		.then(res => {

			if (res.data.length == 0 && page > 1) {
				setSearchParams({target, format, page:1, limit});
				fetchData(target, format, 1, limit, itemId);
			} else {
				setItemData(res.data);
				
				let cnt = res.cnt;
				setTotalCnt(res.cnt);
				
				setKeyData(keyData.map(i => {
					if (i.searchKey == target) {
						return { ...i, count: cnt };
					}
					return i;
				}));
				
				
				setBabyData(babyData.map(i => {
					if (i.searchKey == target) {
						return { ...i, count: cnt };
					}
					return i;
				}));
				
				
				
			}
		});
		setTarget(target);
		setFormat(format);
		setPage(page);
		setLimit(limit);
		
		setGeneralStorage('itemAnalysisMain', target);
		setGeneralStorage('itemAnalysisFormat', format);
	}
	
	
	
	
	
	const generalItemUpload = async (itemId, selectedFile) => {
		try {
			const data = new FormData();
			data.append("itemId", itemId);
			data.append("generalfile", selectedFile);
			
			let res = await postFormData("utility/generalItemUpload", data, navigate);
			return res.data;
		} catch (err) {
			return null;
			console.log(err);
		}
	}
	
	
	const linkItemWithImage = (itemId, path) => {
		let obj = {
			itemId, path
		}
		
		postData("item/linkItemWithImage", obj, navigate); 
	
	}
	
	
	const choosePage = (page) => {	
		let target = searchParams.get("target") || null;
		let format = searchParams.get("format") || null;
		let limit = searchParams.get("limit") || 100;
		
		let myParam = {target, format, page, limit, itemId};
		setSearchParams(myParam);

		if (target == null || format == null || page == null || limit == null) { return; }
		
		fetchData(target, format, page, limit, itemId);
	}
	
	const chooseFormat = (format) => {
		let target = searchParams.get("target") || null;
		let page = searchParams.get("page") || 1;
		let limit = searchParams.get("limit") || 100;
		
		let myParam = {target, format, page, limit, itemId};
		setSearchParams(myParam);

		if (target == null || format == null || page == null || limit == null) { return; }
		
		fetchData(target, format, page, limit, itemId);
	}
	
	const chooseTarget = (target) => {
		let format = searchParams.get("format") || null;
		let page = searchParams.get("page") || 1;
		let limit = searchParams.get("limit") || 100;
		
		let myParam = {target, format, page, limit};
		setSearchParams(myParam);

		if (target == null || format == null || page == null || limit == null) { return; }
		
		fetchData(target, format, page, limit);
	}
	
	const generalFetch = () => {
		let target = searchParams.get("target") || (getGeneralStorage('itemAnalysisMain') ?? "key-reading");
		let format = searchParams.get("format") || (getGeneralStorage('itemAnalysisFormat') ?? "basic");
		let page = searchParams.get("page") || 1;
		let limit = searchParams.get("limit") || 100;
		
		if (target == null || format == null || page == null || limit == null) { return; }
		
		setSearchParams({target, format, page, limit, itemId});
		fetchData(target, format, page, limit, itemId);
	}
	
	useEffect(() => {		
		generalFetch();
	}, []);

	return (<div style={{display:"flex", flexDirection:"column", color:"#4b3f1b"}}>
		<div className={s.header}>
			<div>Item Summary</div>
		
		
			<div className={s.imageUpload}>			
				<label htmlFor="imgs-upload" className={s.custom_file_upload}>
					<input id="imgs-upload" type="file" style={{display:"none"}} multiple onChange={
						async (e) => {
							for(let f of e.target.files) {
								let itemId = f.name.substring(0, f.name.lastIndexOf('.'))
								if (!isNaN(+itemId)) {
									let path = await generalItemUpload(itemId, f);
							
									if (path) {
										linkItemWithImage(itemId, path);
									}
								}
							}
						}} />
					Upload Image
				</label>
			</div>
		
		
		</div>
		<div className={s.paramHolder}>
			<div style={{display:"flex"}}>
				<div style={{display:"flex", padding:"10px 0 0 0"}}>
					<div className={s.nonClickableTitle}>
						<span>Create Item</span>
					</div>
					<div style={{fontWeight:"bold"}}>:</div>	
					<div style={{margin:"auto 10px"}}>
						<div className={s.toggle} onClick={()=>setToggleOn(t => !t)}>{(toggleOn)?"-":"+"}</div>
					</div>
				</div>
				
			</div>
			{
				(toggleOn) && (<CreateBook updateData={()=>generalFetch()}/>)
			}
		</div>
		<div className={s.paramHolder}>
			<div style={{display:"flex", borderBottom:"1px solid #4b3f1b"}}>
				<div style={{display:"flex", padding:"10px 0 0 0"}}>
					<div className={s.nonClickableTitle}>
						<span style={{cursor:"pointer"}}>Key-Item</span>
					</div>
					<div style={{fontWeight:"bold"}}>:</div>		
				</div>
				<div className={s.paramSectionHolder}>
					{
						keyData.map(
							(d, indexD) => (<>
								<div key={'ki-'+indexD} className={s.clickableOption}
									style={(target == d.searchKey) ? {background:"#ebccad"} : {}}
									onClick={() => {
										if (d.searchKey != target) {
											chooseTarget(d.searchKey)
										}
									}}>
									<ItemTypeIcon itemType={d.itemType}/>
									<div>{d.title} </div>
									{(d.count != null) && (<span className={s.targetCnt}> {d.count}</span>)}
								</div>
								{(indexD != keyData.length-1) &&(<span>•</span>)}
							</>)
						)
					}
				</div>
			</div>
			
			<div style={{display:"flex"}}>
			
				<div style={{display:"flex", padding:"10px 0 0 0"}}>
					<div className={s.nonClickableTitle}>
						<span style={{cursor:"pointer"}}>Baby Book</span>
					</div>
					<div style={{fontWeight:"bold"}}>:</div>		
				</div>
				<div className={s.paramSectionHolder}>
					{
						babyData.map(
							(d, indexD) => (<>
								<div key={'baby-'+indexD} className={s.clickableOption}
									style={(target == d.searchKey) ? {background:"#ebccad"} : {}}
									onClick={() => {
										if (d.searchKey != target) {
											chooseTarget(d.searchKey)
										}
									}}
								>{d.title} 
									{(d.count != null) && (<span className={s.targetCnt}> {d.count}</span>)}
								</div>
								{(indexD != babyData.length-1) &&(<span>•</span>)}
							</>)
						)
					}
				</div>
			
			</div>
		</div>
		
		<div className={s.paramHolder}>
			<div style={{display:"flex"}}>
				
				
				<div style={{display:"flex", padding:"10px 0 0 0"}}>
					<div className={s.nonClickableTitle}>Analysis</div>
					<div style={{fontWeight:"bold"}}>:</div>		
				</div>
			
				<div className={s.paramSectionHolder}>
					{
						subData.map(
							(d, indexD) => (<>
								<div key={'format-'+indexD} className={s.clickableOption}
									style={(format == d.searchKey) ? {background:"#ebccad"} : {}}
									onClick={() => {
										if (d.searchKey != format) {
											chooseFormat(d.searchKey)
										}
									}}
									>{d.title}</div>
									{(indexD != subData.length-1) &&(<span>•</span>)}
							</>)
						)
					}
			
				</div>
				
				
				
				
			</div>
		</div>
		
		<div className={s.paramHolder}>
			<div style={{display:"flex"}}>
				<div style={{display:"flex", padding:"10px 0 0 0"}}>
					<div className={s.nonClickableTitle}>Page</div>
					<div style={{fontWeight:"bold"}}>:</div>		
				</div>
				<div className={s.paramSectionHolder} >
					<PagePanel totalCnt={totalCnt} page={page} choosePage={choosePage} limit={limit}/>
				</div>
			</div>
		</div>
		
		{(target== 'key-lucky-bag') && (<KeyLuckyBagPanel />)}
		{(target== 'key-complex-sentence') && (<KeyComplexSentencePanel />)}
		{(target!= 'key-lucky-bag'
		&& target!= 'key-complex-sentence'
		) && (<DetailPanel data={itemData} setData={setItemData} format={format} target={target} generalFetch={generalFetch}/>)}
		
		
	</div>);
}


const PagePanel = ({totalCnt, page, choosePage, limit}) => {
	if (totalCnt == 0) {
		return (<div style={{padding:"0 15px",margin:"0 5px"}}><span>-</span></div>)
	}
	
	let totalPage = Math.ceil(totalCnt / limit);
	
	return (<div style={{padding:"0",margin:"0", display:"flex", flexWrap:"wrap"}}>
		{
			Array.from({ length: totalPage }, (_, index) => (
				<div className={s.clickableOption + ' ' + s.pagePanelBtn}
					style={(page == (index+1)) ? {background:"#ebccad"} : {}} key={index}
					onClick={() => {
						
						if (index+1 != page) {
							choosePage(index+1)
						}
					}}					
					>
					{index + 1}
				</div>
			))
		}
	</div>);
}

const DetailPanel = ({data, setData, format, target, generalFetch}) => {
	const navigate = useNavigate();
	
	const publishItem = (itemId, indexD) => {
		data[indexD].isPublished = !data[indexD].isPublished;
		
		let obj = {
			'itemId' : itemId,
			'isPublished' : data[indexD].isPublished,
		}
		postData("item/publish", obj, navigate); 
		
		setData([...data]);
	}
	
	
	const AIWords = async (itemId) => {
		let obj = {
			'itemId' : itemId,
		}
		postData("wordApi/itemAIWord", obj, navigate); 
		postData("vocabApi/batch_create_vocab_by_item_id", obj, navigate); 
	}
	
	
	const AIExplanation = async (itemId) => {
		let obj = {
			'itemId' : itemId,
		}
		postData("questionApi/generateItemQuestionsExplanation", obj, navigate); 
	}
	
	
	const GenerateWritingResource = async (itemId) => {
		let obj = {
			'itemId' : itemId,
		}
		postData("vipWritingApi/generateResource", obj, navigate); 
	}
	
	
	const GenerateComplexSentence = async (itemId) => {
		let obj = {
			'itemId' : itemId,
		}
		postData("complexSentenceApi/genArticleComplexSentenceByItemId", obj, navigate).then(async () => {
			await postData("complexSentenceApi/checkAllItemComplexSentence", obj, navigate); 
			generalFetch();
		});		
	}
	
	
	
	if (format == 'theme') {
		return (<div style={{margin:"10px 0", fontSize:"0.8rem"}}>
				<div className={s.tableHeaderHolder}>
					<div className={s.tableHeaderPublished} >Pub.?</div>
					<div className={s.tableHeader} style={{flex: '0 0 60px'}}>Id</div>
					<div className={s.tableHeader} style={{flex: '0 0 45px'}}>Type</div>
					<div className={s.tableHeader} style={{flex: '0 0 67px'}}></div>
					<div className={s.tableHeader} style={{flex: '0 0 500px'}}>Name</div>
					<div className={s.tableHeader} style={{flex: '0 0 165px'}}>Theme</div>
				</div>
			{
				data.map((d, indexD) => {
					let bgcolor = (indexD%2==0) ? "white" : "#22222222";
					
					if (d.ownerId) {
						//bgcolor = (indexD%2==0) ? "#d3f5c6" : "#b5eedb"
						//bgcolor = (indexD%2==0) ? "#d3f5c6" : "#c7f0ca"
						bgcolor = "#d3f5c6";
					}
					
					
					return(<div key={'basic-' + indexD}
					className={s.tableRowHolder}
					style={{backgroundColor:(indexD%2==0) ? "white" : "#22222222" }} >
					{
						(d.isPublished == 0) && (<div className={s.publishedHolder} onClick={()=>publishItem(d.itemId, indexD)}>
							<div>
								<div></div>
							</div>
						</div>)
					}
					{
						(d.isPublished == 1) && (<div className={s.publishedHolderTrue} onClick={()=>publishItem(d.itemId, indexD)}>
							<Image className={s.iconSmall} fluid src={starPng} rounded />
						</div>)
					}
					
					
					
					<div className={s.tableRow} style={{flex: '0 0 60px', marginTop:"5px"}}>
						<span style={{fontWeight:"bold"}}>{d.itemId}</span>
					</div>
					
					<div className={s.tableRow} style={{flex: '0 0 50px'}}>
						<ItemTypeIcon itemType={d.itemType}/>
					</div>
					
					<div className={s.tableRow} style={{flex: '0 0 50px', marginTop:"5px"}}>
						<Link className={s.detailButton} to={`/generalitem/${d.itemId}`} target="_blank" rel="noopener noreferrer">
							View
						</Link>
					</div>
					<div className={s.tableRow} style={{flex: '0 0 500px', marginTop:"5px"}}>{d.name}</div>
					<div className={s.tableRow} style={{flex: '0 0 800px', marginTop:"5px"}}>{d.themeNames}</div>
				
				</div>)})
			}
		
		</div>);
	} else {
		return (<div style={{margin:"10px 0", fontSize:"0.8rem"}}>
				<div className={s.tableHeaderHolder}>
					<div className={s.tableHeaderPublished} >Pub.?</div>
					<div className={s.tableHeader} style={{flex: '0 0 60px'}}>Id</div>
					<div className={s.tableHeader} style={{flex: '0 0 45px'}}>Type</div>
					<div className={s.tableHeader} style={{flex: '0 0 67px'}}></div>
					<div className={s.tableHeader} style={{flex: '0 0 500px'}}>Name</div>
					<div className={s.tableHeader} style={{flex: '0 0 400px'}}>Course Name</div>
					{/*
						(["key-teaching-note", "key-tips-bag"].includes(target)) && (<div className={s.tableHeader} style={{flex: '0 0 165px'}}>Tip Type</div>)
					}
					{
						(!["key-teaching-note", "key-tips-bag"].includes(target)) && (<div className={s.tableHeader} style={{flex: '0 0 165px'}}>Text Type</div>)
					*/}
					{/*<div className={s.tableHeader} style={{flex: '0 0 275px'}}>Text Type Grouper</div>*/}
				</div>
			{
				data.map((d, indexD) => {
					let bgcolor = (indexD%2==0) ? "white" : "#22222222";
					
					if (d.ownerId) {
						//bgcolor = (indexD%2==0) ? "#d3f5c6" : "#b5eedb"
						//bgcolor = (indexD%2==0) ? "#d3f5c6" : "#c7f0ca"
						bgcolor = "#d3f5c6";
					}
					
					
					return(<div key={'basic-' + indexD}
					className={s.tableRowHolder}
					style={{backgroundColor:bgcolor}} >
					
					
					{
						(d.isPublished == 0) && (<div className={s.publishedHolder} onClick={()=>publishItem(d.itemId, indexD)}>
							<div>
								<div></div>
							</div>
						</div>)
					}
					{
						(d.isPublished == 1) && (<div className={s.publishedHolderTrue} onClick={()=>publishItem(d.itemId, indexD)}>
							<Image className={s.iconSmall} fluid src={starPng} rounded />
						</div>)
					}
					
					
					
					<div className={s.tableRow} style={{flex: '0 0 60px', marginTop:"5px"}}>
						<span style={{fontWeight:"bold"}}>{d.itemId}</span>
					</div>
					
					<div className={s.tableRow} style={{flex: '0 0 50px'}}>
						<div style={{display:"flex", alignItems:"center"}}>
							<ItemTypeIcon itemType={d.itemType}/>
							{
								(d.ownerId) && (<div className={s.jailUserIcon}>
									<Image className={s.iconSmall} fluid src={jailPng} rounded />
								</div>)
							}
						</div>
					</div>
					
					<div className={s.tableRow} style={{flex: '0 0 50px', marginTop:"5px"}}>
						<Link className={s.detailButton} to={`/generalitem/${d.itemId}`} target="_blank" rel="noopener noreferrer">
							View
						</Link>
					</div>
					<div className={s.tableRow} style={{flex: '0 0 500px', marginTop:"5px"}}>{d.name}</div>
					<div className={s.tableRow} style={{flex: '0 0 400px', marginTop:"5px", letterSpacing:"-0.05rem", fontSize:"0.9rem"}}>{(d.courseName) ? d.courseName : "N/A"}</div>
					
					
					{/*
						(["key-teaching-note", "key-tips-bag"].includes(target)) && (<div className={s.tableRow} style={{flex: '0 0 165px', marginTop:"5px", letterSpacing:"-0.05rem", fontSize:"1rem"}}>{d.noteType}</div>)
					}
					{
						(!["key-teaching-note", "key-tips-bag"].includes(target)) && (<div className={s.tableRow} style={{flex: '0 0 165px', marginTop:"5px", letterSpacing:"-0.05rem", fontSize:"0.9rem"}}>{d.textType}</div>)
					*/}
					
					
					
					
					{/*<div className={s.tableRow} style={{flex: '0 0 275px', marginTop:"5px", letterSpacing:"-0.05rem", fontSize:"0.9rem"}}>{d.textTypeGrouper}</div>*/}
					{(d.itemType == 81 || ((!d.overrideItem) && (!d.questionStatus || !d.questionStatus.isValid))) && (<div className={s.tableRow} style={{flex: '0 0 100px', marginTop:"5px", letterSpacing:"-0.05rem", fontSize:"0.9rem", display:"flex"}}>
						<div className={s.detailButton} style={{width:"35px"}} onClick={()=>{AIWords(d.itemId)}}>AI</div>
						<div style={{width:"120px"}}>
						{
						((!d.overrideItem) && (!d.questionStatus || !d.questionStatus.isValid)) && (<div className={s.detailButton} onClick={()=>{AIExplanation(d.itemId)}}>Explanation</div>)
						}
						
						{
						(d.itemType == 81 && (!d.writingResourceStatus)) && (<div className={s.detailButton} onClick={()=>{GenerateWritingResource(d.itemId)}}>Writing</div>)
						}
						{
						(d.itemType == 81 && (d.writingResourceStatus)) && (<div className={s.detailButtonBlue}  onClick={()=>{GenerateWritingResource(d.itemId)}}>Force Writing</div>)
						}
						
						</div>
					</div>)}
					{
						(!d.overrideItem) && (!d.complexStatus || !d.complexStatus.isValid) && (<GreenButton isEnabled={true} clickedAction={()=>GenerateComplexSentence(d.itemId)} bText={"Complex Sentence"} />)
					}

					{
						d.overrideItem && (
							<Link 
							// CONDITIONAL CLASS: Red if invalid, Blue if valid
							className={d.overrideItem.overrideItemId != null && // Override ID is valid
							(
								d.overrideItem.paragraphStartIdx == null ||
								d.overrideItem.paragraphEndIdx == null ||
								d.overrideItem.qtnStartIdx == null ||
								d.overrideItem.qtnEndIdx == null
							) ? s.detailButtonRed : s.detailButtonBlue}
							to={`/generalitem/${d.overrideItem.overrideItemId}`}
							target="_blank"
							rel="noopener noreferrer"
							>
							Extracted From: {d.overrideItem.overrideItemId} 
							{` p${d.overrideItem.paragraphStartIdx == null ? '?' : d.overrideItem.paragraphStartIdx}-p${d.overrideItem.paragraphEndIdx == null ? '?' : d.overrideItem.paragraphEndIdx} q${d.overrideItem.qtnStartIdx == null ? '?' : d.overrideItem.qtnStartIdx}-q${d.overrideItem.qtnEndIdx == null ? '?' : d.overrideItem.qtnEndIdx}`}
							</Link>
						)
						}

					{
						(!d.overrideItem) && (!d.questionStatus || !d.questionStatus.isValid) && (<div>Invalid Q ({d.questionStatus.isValidCount})</div>)
					}
				</div>)})
			}
		
		</div>);
	} 
	return (<div>oops...</div>)
}





const babyDefaultData = [
	{ title: 'Baby', searchKey: 'baby', availableFormat:[] },
	{ title: 'Phonics', searchKey: 'phonics', availableFormat:[] },
	{ title: 'Poem', searchKey: 'poem', availableFormat:[] }
]

const subData = [
	{ title: 'Basic', searchKey: 'basic'},
	{ title: 'Theme', searchKey: 'theme'},
]